import { Charts } from './Charts';
import PhonesChartsDataProvider from './contexts/PhonesChartsDataContext';

const PhonesWrapper = () => {
    return (
        <PhonesChartsDataProvider>
            <Charts />
        </PhonesChartsDataProvider>
    );
};

export default PhonesWrapper;
